import React, { useState, useEffect } from 'react';
import { AccountFinal } from '@/api/entities';
import { Loader2, CheckCircle, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const techData = [
  {"account_name": "Australian Film, Television and Radio School", "sis_vendor": "Paradigm", "lms_vendor": "Moodle", "crm_vendor": "Salesforce", "eportfolio_vendor": "None"},
  {"account_name": "Australian University of Theology", "sis_vendor": "Paradigm", "lms_vendor": "Moodle", "crm_vendor": "N/A", "eportfolio_vendor": "None"},
  {"account_name": "Avondale University", "sis_vendor": "Callista", "lms_vendor": "Moodle", "crm_vendor": "Dynamics 365", "eportfolio_vendor": "PebblePad"},
  {"account_name": "Batchelor Institute of Indigenous Tertiary Education", "sis_vendor": "Callista", "lms_vendor": "Moodle", "crm_vendor": "Tribal", "eportfolio_vendor": "None"},
  {"account_name": "Bond University", "sis_vendor": "Callista", "lms_vendor": "Moodle", "crm_vendor": "Recruitment CRM", "eportfolio_vendor": "Olster - Health Sciences"},
  {"account_name": "Central Queensland University", "sis_vendor": "TechnologyOne", "lms_vendor": "Moodle", "crm_vendor": "SugarCRM", "eportfolio_vendor": "Portfolium"},
  {"account_name": "Charles Darwin University", "sis_vendor": "Callista", "lms_vendor": "Blackboard Learn.", "crm_vendor": "Internal", "eportfolio_vendor": "PebblePad"},
  {"account_name": "Charles Sturt University", "sis_vendor": "Ellucian Banner", "lms_vendor": "D2L Corp.", "crm_vendor": "Dynamics 365", "eportfolio_vendor": "PebblePad"},
  {"account_name": "Curtin University", "sis_vendor": "Student One", "lms_vendor": "Blackboard Learn.", "crm_vendor": "Salesforce", "eportfolio_vendor": "In-house, PebblePad - Health Sciences"},
  {"account_name": "Deakin University", "sis_vendor": "Callista", "lms_vendor": "D2L Corp.", "crm_vendor": "Callista", "eportfolio_vendor": "PebblePad"},
  {"account_name": "Federation University Australia", "sis_vendor": "PeopleSoft", "lms_vendor": "Moodle", "crm_vendor": "StudyLink Connect", "eportfolio_vendor": "Mahara, PebblePad (pilot)"},
  {"account_name": "James Cook University", "sis_vendor": "TechnologyOne", "lms_vendor": "Blackboard Learn.", "crm_vendor": "Oracle Service Cloud", "eportfolio_vendor": "PebblePad"},
  {"account_name": "La Trobe University", "sis_vendor": "Student One", "lms_vendor": "Moodle", "crm_vendor": "StudyLink Connect", "eportfolio_vendor": "Portfolium"},
  {"account_name": "Macquarie University", "sis_vendor": "Student One", "lms_vendor": "Moodle", "crm_vendor": "Salesforce", "eportfolio_vendor": "Portfolium"},
  {"account_name": "Monash University", "sis_vendor": "Callista", "lms_vendor": "Moodle", "crm_vendor": "Salesforce", "eportfolio_vendor": "Mahara - Primary, PebblePad - Medicine"},
  {"account_name": "Murdoch University", "sis_vendor": "Callista", "lms_vendor": "Moodle", "crm_vendor": "Salesforce", "eportfolio_vendor": "PebblePad"},
  {"account_name": "Southern Cross University", "sis_vendor": "TechnologyOne", "lms_vendor": "Blackboard Learn.", "crm_vendor": "Salesforce", "eportfolio_vendor": "Blackboard"},
  {"account_name": "University of Divinity", "sis_vendor": "Paradigm", "lms_vendor": "Moodle", "crm_vendor": "Dynamics 365", "eportfolio_vendor": "None"},
  {"account_name": "University of New England", "sis_vendor": "Callista", "lms_vendor": "Moodle", "crm_vendor": "Paradigm", "eportfolio_vendor": "PebblePad"},
  {"account_name": "University of New South Wales", "sis_vendor": "PeopleSoft", "lms_vendor": "Moodle", "crm_vendor": "Oracle Service Cloud", "eportfolio_vendor": "Mahara - Biomedical Sciences, PebblePad - Engineering"},
  {"account_name": "University of Notre Dame Australia", "sis_vendor": "PeopleSoft", "lms_vendor": "Blackboard Learn.", "crm_vendor": "Dynamics 365", "eportfolio_vendor": "Blackboard"},
  {"account_name": "University of Queensland", "sis_vendor": "PeopleSoft", "lms_vendor": "Blackboard Learn.", "crm_vendor": "StudyLink Connect", "eportfolio_vendor": "Blackboard"},
  {"account_name": "University of South Australia", "sis_vendor": "PeopleSoft", "lms_vendor": "Moodle", "crm_vendor": "Oracle Service Cloud", "eportfolio_vendor": "PebblePad"},
  {"account_name": "University of Southern Queensland", "sis_vendor": "PeopleSoft", "lms_vendor": "Moodle", "crm_vendor": "Salesforce", "eportfolio_vendor": "CampusPress"},
  {"account_name": "University of Tasmania", "sis_vendor": "Callista", "lms_vendor": "D2L Corp.", "crm_vendor": "Oracle Service Cloud", "eportfolio_vendor": "PebblePad"},
  {"account_name": "University of Western Australia", "sis_vendor": "Callista", "lms_vendor": "Blackboard Learn.", "crm_vendor": "Oracle Service Cloud (RightNow) + Oracle Eloqua", "eportfolio_vendor": "Blackboard, PebblePad (MD Cohort)"},
  {"account_name": "University of Wollongong", "sis_vendor": "PeopleSoft", "lms_vendor": "Moodle", "crm_vendor": "Salesforce", "eportfolio_vendor": "None"},
  {"account_name": "Victoria University", "sis_vendor": "TechnologyOne", "lms_vendor": "D2L Corp.", "crm_vendor": "Oracle Service Cloud", "eportfolio_vendor": "PebblePad"},
  {"account_name": "Western Sydney University", "sis_vendor": "Ellucian Banner", "lms_vendor": "Blackboard Learn.", "crm_vendor": "Dynamics 365", "eportfolio_vendor": "MyShowcase.me"}
];

export default function TempDataUpdate() {
    const [status, setStatus] = useState('idle'); // idle, running, done
    const [logs, setLogs] = useState([]);
    const [summary, setSummary] = useState({ updated: 0, notFound: 0, errors: 0 });

    const runUpdate = async () => {
        setStatus('running');
        setLogs([]);
        setSummary({ updated: 0, notFound: 0, errors: 0 });

        let tempSummary = { updated: 0, notFound: 0, errors: 0 };
        
        const addLog = (message, type = 'info') => {
            setLogs(prev => [...prev, { message, type }]);
        };

        addLog(`Fetching all accounts from the database...`);
        const allAccounts = await AccountFinal.list();
        addLog(`Found ${allAccounts.length} accounts.`);

        for (const [index, item] of techData.entries()) {
            addLog(`[${index + 1}/${techData.length}] Processing: ${item.account_name}`);
            const accountToUpdate = allAccounts.find(acc => acc.account_name === item.account_name);

            if (accountToUpdate) {
                try {
                    const payload = {
                        lms_vendor: item.lms_vendor,
                        sis_vendor: item.sis_vendor,
                        crm_vendor: item.crm_vendor,
                        eportfolio_vendor: item.eportfolio_vendor,
                    };
                    await AccountFinal.update(accountToUpdate.id, payload);
                    addLog(`Successfully updated ${item.account_name}.`, 'success');
                    tempSummary.updated++;
                } catch (error) {
                    addLog(`Error updating ${item.account_name}: ${error.message}`, 'error');
                    tempSummary.errors++;
                }
            } else {
                addLog(`Account not found in database: ${item.account_name}`, 'warning');
                tempSummary.notFound++;
            }
            setSummary({...tempSummary});
        }
        
        addLog('--- UPDATE COMPLETE ---', 'info');
        setStatus('done');
    };

    return (
        <div className="max-w-4xl mx-auto p-8 bg-white shadow-lg rounded-lg my-10">
            <h1 className="text-2xl font-bold mb-4 text-gray-800">Account Data Migration</h1>
            <p className="mb-6 text-gray-600">
                This script will update existing accounts with the new tech product information.
                Click the button below to start the process.
            </p>

            {status === 'idle' && (
                <Button onClick={runUpdate} className="bg-blue-600 hover:bg-blue-700">
                    Start Data Update
                </Button>
            )}

            {status === 'running' && (
                <div className="flex items-center gap-3 text-lg font-semibold text-gray-700">
                    <Loader2 className="w-6 h-6 animate-spin" />
                    Processing... Please do not close this window.
                </div>
            )}
            
            {status === 'done' && (
                <div className="flex items-center gap-3 text-lg font-semibold text-green-600">
                    <CheckCircle className="w-6 h-6" />
                    Update Process Finished!
                </div>
            )}

            <div className="mt-6 border-t pt-4">
                <h2 className="font-semibold mb-2">Summary:</h2>
                <div className="flex gap-4">
                    <div className="text-green-600">Updated: {summary.updated}</div>
                    <div className="text-yellow-600">Not Found: {summary.notFound}</div>
                    <div className="text-red-600">Errors: {summary.errors}</div>
                </div>
            </div>

            <div className="mt-4 bg-gray-900 text-white font-mono text-sm rounded-lg p-4 h-64 overflow-y-auto">
                {logs.map((log, index) => (
                    <div key={index} className={`flex items-start ${
                        log.type === 'success' ? 'text-green-400' :
                        log.type === 'error' ? 'text-red-400' :
                        log.type === 'warning' ? 'text-yellow-400' : ''
                    }`}>
                        {log.type === 'error' && <AlertTriangle className="w-4 h-4 mr-2 mt-0.5 shrink-0" />}
                        <span className="break-all">{log.message}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}